export default {
	REGULAR: 'regular',
	GOALS: 'goals',
	QUICK_LAUNCH: 'quick-launch',
}
